import React from "react";
import { Field, Input } from "@fluentui/react-components";
import { Breadcrumbs } from "#root/components/Breadcrumbs";
import "./styles.scss";

interface SuperAdminFormProps {
  title: string;
  formData: {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
  };
  errors: Record<string, string>;
  onChange: (field: keyof SuperAdminFormProps["formData"], value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  extraFieldsAfterEmail?: React.ReactNode;
  extraFields?: React.ReactNode;
  actions: React.ReactNode;
  children?: React.ReactNode;
}

const SuperAdminForm: React.FC<SuperAdminFormProps> = ({
  title,
  formData,
  errors,
  onChange,
  onSubmit,
  extraFieldsAfterEmail,
  extraFields,
  actions,
  children,
}) => {
  return (
    <div className="superadmin-form-page">
      <div className="emc-page-header">
        <div className="emc-page-header__top-row">
          <Breadcrumbs />
        </div>
        <div className="emc-page-header__title">
          <h2>
            {title}
            <div className="divider" />
          </h2>
        </div>
      </div>
      <form onSubmit={onSubmit} className="form-container">
        <div className="field-two-columns">
          <Field
            label="First Name"
            required
            validationState={errors.firstName ? "error" : "none"}
            validationMessage={errors.firstName}
          >
            <Input
              value={formData.firstName}
              onChange={(_, data) => onChange("firstName", data.value)}
            />
          </Field>
          <Field
            label="Last Name"
            required
            validationState={errors.lastName ? "error" : "none"}
            validationMessage={errors.lastName}
          >
            <Input
              value={formData.lastName}
              onChange={(_, data) => onChange("lastName", data.value)}
            />
          </Field>
        </div>
        <Field
          label="Email"
          required  
          validationState={errors.email ? "error" : "none"}
          validationMessage={errors.email}
        >
          <Input
            autoComplete="off"
            type="email"
            value={formData.email}
            onChange={(_, data) => onChange("email", data.value)}
          />
        </Field>
        {extraFieldsAfterEmail}
        <Field label="Phone Number">
          <Input
            type="tel"
            value={formData.phoneNumber}
            onChange={(_, data) => onChange("phoneNumber", data.value)}
          />
        </Field>
        {extraFields}
        {children}
        <div className="form-actions">{actions}</div>
      </form>
    </div>
  );
};

export default SuperAdminForm;
